import React, { Component } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import ContactForm from "../pages/contact/form";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const TestimonialNew = class extends React.Component {
  render() {
    const settings = {
      dots: false,
      fade: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 500,
      arrows: false,
      pauseOnHover: false,
    };
    return (
      <section className="home-contact">
        <div className="testimonial">
          <p className="yellow-text">Don’t just take our word for it</p>
          <span className="highlight q1">"</span>
        <Slider {...settings}>
          <div>
            <p className="testimonial-text">
            Partnering with Nathan has definitely been a great choice. He has since demonstrated what a talented recruitment partner he is, always delivering great candidates & ensuring to provide a first class candidate experience as well. Looking forward to the success of this partnership.<span className="highlight q2">"</span>
            </p>
            <p className="yellow-text">Laura De Jaen</p>
            <p className="white-text">(Talent Manager) - Social Point</p>
            <p className="yellow-text padtop">★★★★★</p>
          </div>
          <div>
            <p className="testimonial-text">
            Thoroughly enjoyed working with Nathan for our most recent role. The candidates put forward were of a very high standard and all very engaged and up for the challenge of our interview process. I'm looking forward to working with him in the future.<span className="highlight q2">"</span>
            </p>
            <p className="yellow-text">Guy Newsom</p>
            <p className="white-text">(VP Product & Design) - XYZ Reality</p>
            <p className="yellow-text padtop">★★★★★</p>
          </div>
          <div>
            <p className="testimonial-text">
            Easily the best recruiter I have worked with. In the past, I have been represented by Nathan, and he was brilliant. Now we work with Nathan to recruit UX'rs & Products Designers for our team. He always finds us great candidates, and is open and honest about the people he puts forward.  Would highly recommend Nathan to represent you or to find you amazing people.<span className="highlight q2">"</span>
            </p>
            <p className="yellow-text">Drew Tavernier</p>
            <p className="white-text">(Lead Product Designer) - Dunelm</p>
            <p className="yellow-text padtop">★★★★★</p>
          </div>
        </Slider>
        </div>
        <div className="contact-form-small" id="contact-form">
        <ContactForm />
        </div>
      </section>
    );
  }
};

export default TestimonialNew;